import React, { useCallback, type SyntheticEvent } from 'react';
import { ContextMenuItem } from '@web-chat-core/ui-kit/core/ContextMenu/view';
import { type ColorVariants, type TypoVariants } from '@web-chat-core/ui-kit/core/Typography';
import { MenuItemDisabled, MenuItemContent, DropdownMenuItem } from './view';

interface MenuItemProps {
    id: string;
    onClick: (e: SyntheticEvent | Event) => void;
    children: React.ReactNode;
    isDisabled?: boolean;
    type?: 'context' | 'dropdown';
    variant?: TypoVariants;
    colorVariant?: ColorVariants;
    cy?: string;
    className?: string;
}

export const MenuItem = ({
    children,
    variant = 'body3',
    colorVariant,
    id,
    isDisabled,
    onClick,
    type = 'dropdown',
    cy,
    className,
}: MenuItemProps) => {
    const handleSelect = useCallback(
        (e: Event) => {
            onClick(e);
        },
        [onClick],
    );

    if (isDisabled) {
        return (
            <MenuItemDisabled
                key={id}
                data-cy={cy}
                className={className}
            >
                <MenuItemContent
                    variant={variant}
                    colorVariant={colorVariant}
                >
                    {children}
                </MenuItemContent>
            </MenuItemDisabled>
        );
    }

    return (
        <>
            {type === 'dropdown' ? (
                <DropdownMenuItem
                    key={id}
                    onSelect={handleSelect}
                    className={className}
                >
                    <MenuItemContent
                        variant={variant}
                        colorVariant={colorVariant}
                        cy={cy}
                    >
                        {children}
                    </MenuItemContent>
                </DropdownMenuItem>
            ) : (
                <ContextMenuItem
                    key={id}
                    onSelect={handleSelect}
                    className={className}
                >
                    <MenuItemContent
                        variant={variant}
                        colorVariant={colorVariant}
                        cy={cy}
                    >
                        {children}
                    </MenuItemContent>
                </ContextMenuItem>
            )}
        </>
    );
};

MenuItem.displayName = 'MenuItem';
